import Vue from 'vue';

export default {
  data() {
    return {
      intervalId: null,
      interval: 15000,
      ticketDetail: {}, // 返回工单详情
      commonTicketNo: '',
      fileList: [], // 如果上传附件
      draftDisabled: false,
      isTriggerChangeIdcid: true,
      draftUuid: this.getId(),
      requestDisabled: false
    };
  },
  watch: {
    requestDisabled: {
      handler(val) {
        if (val) {
          clearInterval(this.intervalId);
        } else {
          this.intervalId = setInterval(() => {
            // 调用草稿接口
            this.saveDraft();
          }, this.interval);
        }
      },
      deep: true
    }
  },
  methods: {
    getId() {
      // 生成前台唯一id
      return `${(Math.random() * 10000000)
        .toString(16)
        .substr(0, 4)}-${new Date().getTime()}-${Math.random()
        .toString()
        .substr(2, 5)}`;
    },
    getRestListOnlyId(list) {
      if (list && list instanceof Array) {
        const entryList = [].concat(list);
        entryList.forEach((item) => {
          item.onlyid = this.getId();
        });
        console.log(entryList);
        return entryList;
      }
      return [];
    },
    checkDataIsEdit(objectData, checkArr, otherData = []) {
      // objectData是ruleForm. checkArr是ruleForm中需要编辑的数据
      // otherData和ruleForm无关的数据
      const isEditArr = [];
      checkArr.some((strItem) => {
        const type = typeof objectData[strItem];
        if (type === 'string' && objectData[strItem].length) {
          // 字符串
          isEditArr.push(strItem);
          return false;
        }
        if (type === 'object') {
          if (objectData[strItem] instanceof Array && objectData[strItem].length) {
            // 数组
            isEditArr.push(strItem);
            return false;
          }
        } else if (type === 'boolean' || type === 'number') {
          // number和boolean
          isEditArr.push(strItem);
          return false;
        }
      });
      return !!isEditArr.length || !!otherData.length;
    },
    filterEditedData() {
      const param = this.submitParams();
      const filterParam = {};
      Object.keys(param).forEach((key) => {
        const type = typeof param[key];
        if (type === 'string' && param[key].length) {
          // 字符串
          filterParam[key] = param[key];
        } else if (type === 'object') {
          if (param[key] instanceof Array) {
            // 数组
            if (param[key].length) {
              filterParam[key] = param[key];
            }
          } else if (param[key] instanceof Object) {
            const keyArr = Object.keys(param[key]);
            if (keyArr.length) {
              filterParam[key] = param[key];
            }
          }
        } else if (type === 'boolean' || type === 'number') {
          // number和boolean
          filterParam[key] = param[key];
        }
      });
      return filterParam;
    },
    submitDraft(checkData, flag = false) {
      // checkData是检查编辑的数据， 数组类型。
      // checkData的前两项是ruleForm. 和ruleForm中需要编辑的数据
      // checkData中的第三项数据是和ruleForm无关的数据
      const isEdit = this.checkDataIsEdit(...checkData);
      if (isEdit) {
        // 已经编辑提交编辑内容
        const param = this.filterEditedData();
        // 判断工单是否已经提交过
        // 已提交工单 有id 传id 没有id 参数不变
        this.commonTicketNo = this.$route.query.ticketNo || window.sessionStorage.getItem('ticketNo');
        if (typeof this.commonTicketNo !== 'object') {
          param.ticketNo = this.commonTicketNo;
        } else {
          param.ticketNo = '';
          this.commonTicketNo = '';
        }
        let api = '';
        if (flag) {
          this.draftDisabled = true;
          api = 'saveDraft';
        } else {
          api = 'saveDraftNoTips';
        }
        param.draftUuid = this.draftUuid;
        console.log(param);
        this.$api[api](param)
          .then((res) => {
            if (res.errno === 10000) {
              this.commonTicketNo = res.data.ticketNo;
              if (flag) {
                this.$router.push('/myworksheet/list');
              } else {
                window.sessionStorage.setItem('ticketNo', res.data.ticketNo);
              }
            }
          })
          .catch((err) => {
            this.$message.error(err.msg);
          })
          .finally(() => {
            // 并控制断言的正确执行时机
            this.draftDisabled = false;
          });
      } else {
        // 没有编辑做出相对应的提示
        if (flag) {
          // this.$message.warning('请编辑草稿！');
          this.$message.warning(Vue.prototype.Config.ROOT_VUE.$t('text.editDraft'));
        }
      }
    },
    // 编辑回写表单
    resetRuleForm(map, from, fn = () => {}) {
      // 表单相同的回写\
      console.log(159, '------')
      Object.keys(from).forEach((k) => {
        if (this.ticketDetail[k] !== undefined) {
          from[k] = this.ticketDetail[k];
          console.log(109, k, this.ticketDetail[k], from[k]);
        }
      });
      // 表单不同
      Object.keys(map).forEach((k) => {
        if (this.ticketDetail[k] !== undefined) {
          from[map[k]] = this.ticketDetail[k];
        }
      });
      // 针对不同工单可写回调函数
      fn();
      // 针对上传附件统一回写
      if (this.ticketDetail.attach && this.ticketDetail.attach.length > 0) {
        const { attachName, attachPath } = this.ticketDetail.attach[0];
        if (attachName && attachPath) {
          this.fileList.push({
            name: attachName,
            url: attachPath
          });
        }
      }
    }
  },
  async created() {
    this.commonTicketNo = this.$route.query.ticketNo || '';
    this.idcLine = this.$route.query.idcLine || '';
    if (this.commonTicketNo !== '') {
      // 标志位 给idcId 赋值不触发事件
      this.isTriggerChangeIdcid = false;
      // 掉接口获取详情
      const detail = await this.$api.getDraftInfo({
        ticketNo: this.commonTicketNo
      });
      this.ticketDetail = detail.data;
      this.parseTicketParams(this.ticketDetail);
    }
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    this.intervalId = setInterval(() => {
      // 调用草稿接口
      this.saveDraft();
    }, this.interval);
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
    // 离开页面时删除session
    window.sessionStorage.removeItem('ticketNo');
  }
};



// WEBPACK FOOTER //
// ./src/components/workSheet/common/draft.mixin.js